import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';


//import './FT.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'

const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    fecha: new Date,
    comentario: "",
    estatus: 0
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    totalLinea: 0.00,
    fecha: new Date
}
const modeloDatosc = {
    clienteID: 0,
    empresaID: 1,
    descripcion: "",
    rnc: "",
    direccion: "",
    telefono: "",
    correo: ""


}

var SubTotal = 0.00;
var totalDescuento = 0.00;
var totalITBIS = 0.00;
var totalPago = 0.00;
var impresion = '';
var Leatendio = '';

const ImpresionFactura = () => {
    let { Pedido } = useParams();
   


    const [ListadoLineas, SetListadoLineas] = useState([modeloDatos1]);
    const [Listado, SetListado] = useState([modeloDatos]);
    const [ListadoClientes, SetListadoClientes] = useState([modeloDatosc]);
    const [Empresa, SetEmpresa] = useState([]);
    const [SN, SetSN] = useState();
    const [VerFactura, SetVerFactura] = useState(true);
    const [VerImprimir, SetVerImprimir] = useState(false);


    useEffect(() => {
        obtenerDatos(Pedido)
       
        
    }, [])

    const obtenerDatosSN = async (e) => {
        let response = await fetch(Api + "Administracion/SecuenciaNumerica");
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.secuenciaID == parseInt(e)).map(x => x.descripcion);
            SetSN(d)
        }
    }

    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "Pacientes/ListaPedidoID/"+ parseInt(e));
        if (response.ok) {
            let data = await response.json();
            SetListado(data[0])
           
            obtenerDatosLineas(data[0].facturaID)
            obtenerDatosClientes(data[0].clienteID)
            obtenerDatosEmpresa(data[0].empresaID)
            obtenerDatosSN(data[0].tipoComprobante)
            obtenerUsuarios(data[0].creadoPor)

            var subt = data[0].subTotal;
            SubTotal = currencyFormatter({
                currency: "USD",
               value: subt
            })
        }
    }

    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "Pacientes/ListaPedidoLineasF/" + pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)

       
        }
    }

    const obtenerDatosClientes = async (c) => {
        let response = await fetch(Api + "VentasMantenimiento/ListaClientesID/"+ c);

        if (response.ok) {
            let data = await response.json()
         SetListadoClientes(data[0])
        }
    }
    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + e);
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.empresaID == e).map(e => e)
            SetEmpresa(d[0])
        }
    }

    const obtenerUsuarios = async (u) => {
        let response = await fetch(Api + "usuario/Lista/1");

        if (response.ok) {
            let data = await response.json()
            let fd = data.filter(x => x.correo == u).map(x => x)
            if (u != 'admin@gmail.com') {
                impresion = fd[0].impresionPuntoVenta;
                Leatendio = fd[0].nombre;
            }
            SetVerFactura(false)
        }
    }

   // function currencyFormatter({ currency, value }) {
    const currencyFormatter=({ currency, value }) =>{
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 2,
            currency
        })
        return formatter.format(value)
    }

    const Imprimir = () => {
        SetVerImprimir(true)
        window.print();
     
    }
   
    //const dollar = currencyFormatter({
    //    currency: "USD",
    //   Listado.subTotal
    //})

    return (
        <>
            <div hidden={VerFactura}>
          {/*   <div className="verturno " hidden={VerFactura} style={{ fontSize: "10px",color:"black"} }>
               <div class="page">
                <div style={{ textAlign: "center" } }><h4>{Empresa.descripcion}</h4>
                <div>{Empresa.direccion}</div>
                <div hidden={Listado.tipoComprobante == 1} > RNC :{Empresa.rnc}</div>
                    Tel:{Empresa.telefono} Correo: {Empresa.email}</div>
                <br></br>
                <div style={{ textAlign: "left" }}>
                    <div>{SN}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                    <div><b>Orden No:</b>{Listado.facturaID}</div>
                    <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>

                    <div hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc}</div>
                    <div><b>Cliente:</b> {Listado.nombreCliente}</div>
                    <div><b>Telefono:</b> {Listado.telefono}</div>
                    <div><b>Dirección:</b> {ListadoClientes.direccion}</div>
                    <div><b>Email: </b>{ListadoClientes.correo}</div>

                
                   
                </div>

                <div >
                    <table>
                       
                            <tr>
                                <th>Descripción</th>
                                <th>Cantidad</th>
                                <th>Precio unitario</th>
                                <th>Total</th>
                            </tr>
                     
                            {ListadoLineas.map(x => (
                                <tr>
                                    <td>{x.descripcionArticulo}</td>
                                    <td>{x.cantidad}</td>
                                    <td>${x.totalLinea.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    <td>${(x.totalLinea * x.cantidad).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                </tr>

                            ))}
                    </table>
                </div>

                <div class=""  >

                    <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                    <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                    <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                    <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                </div>

               </div>

          

            </div>
           
            <div>*/}
             
                <div class="containerP" hidden={!impresion} onClick={() => Imprimir()} >
              
                        <div style={{ textAlign: "center" }}><h4>{Empresa.descripcion}</h4>
                    <div style={{  fontSize: "12px" }} >  <div>{Empresa.direccion}</div>
                        <div  > RNC :{Empresa.rnc}</div>
                        <b>Tel:</b>{Empresa.telefono}  <b>Correo: </b>{Empresa.email}</div>
                      </div>  <br></br>
                <div style={{ textAlign: "left", fontSize: "12px" }}>
                        <div>{SN}</div>
                        <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                        <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                        <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                        <div><b>Orden No:</b>{Listado.facturaID}</div>
                        <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>

                        <div hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc}</div>
                        <div><b>Cliente:</b> {Listado.nombreCliente}</div>
                    <div><b>Telefono:</b> {Listado.telefono} <b>Email: </b>{ListadoClientes.correo}</div>
                        <div><b>Dirección:</b> {ListadoClientes.direccion}</div>
                      



                    </div>
                    <br></br>
               
                <div style={{ textAlign: "left", fontSize: "10px" }} >
                        <table>

                            <tr>
                                <th>Descripción</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                                <th>Total</th>
                            </tr>

                            {ListadoLineas.map(x => (
                                <tr>
                                    <td>{x.descripcionArticulo}</td>
                                    <td>{x.cantidad}</td>
                                    <td>${x.totalLinea.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                    <td>${(x.totalLinea * x.cantidad).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                </tr>

                            ))}
                        </table>
                    </div>
                    <div class="footer">
                        <div class=""  >
{/*hidden={Listado.tipoComprobante != 1}*/}
                        <div ><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal+ Listado.totalITBIS })}</div>
                            <div hidden={true}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                            <div hidden={true} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                    </div>
                        <br></br>
                    <p>Le Atendio: {Leatendio}</p>
                    <p>Gracias por visitarnos</p>
                    <br></br>
                    </div>
                </div>
      

            <div class="letra" hidden={impresion }>

              
                
                <div class="printArea">
                    <div class="page">

                     
                        <html  lang="en">
                        
                                    <body>

                                        <div class="container">
                                    <div class="header">
                                      
                                        <table className="tableh" >
                                            <tr >
                                                <td style={ {width:"20%", border: "0px"}} >
                                            <img class="card-img-top" src="./imagen/LogoApatech.png" style={{ width: '100px', height: '100px' }} />
                                                </td>  
                                                <td style={{ border: "0px" }}>
                                                    <h4><b>{Empresa.descripcion}</b></h4>
                                                   <div>{Empresa.direccion}</div> 
                                                    <div hidden={Listado.tipoComprobante ==1 } > RNC :{Empresa.rnc}</div>
                                                    Tel:{Empresa.telefono} Correo: {Empresa.email}

                                                   
                                                </td>
                                            </tr>
                                        </table>
                                     
                                      
                                            </div>

                                            <div class="bill-info">
                                                <div>
                                                    <h5><b>Cliente:</b></h5>
                                            <p hidden={Listado.tipoComprobante == 1}><b>RNC:</b> {Listado.rnc }</p>
                                        <div><b>Nombre:</b> {Listado.nombreCliente }</div>
                                    <div><b>Telefono:</b> {Listado.telefono }</div>
                                <div><b>Dirección:</b> {ListadoClientes.direccion }</div>
                            <div><b>Email: </b>{ListadoClientes.correo}</div>
                                                <div><b>Seguro: </b>{Listado.nombreSeguro}</div>
                                          
                                                </div>
                                                <div>
                                                <h5><b>Factura:</b></h5>
                                            <div>{SN}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                    <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                    <div><b>Orden No:</b>{Listado.facturaID}</div>
                                            <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>
                                            <div><b>Condición:</b>{Listado.credito == 0 ? 'Contado' : 'Credito' }</div>
                                        </div>
                                            </div>
                                    <div style={{ height: '1.02in'} }>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Cantidad</th>
                                                        <th>Descripción</th>
                                                        {/*<th>ITBIS</th>*/}
                                                        <th>IMPORTE</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                        <tbody>
                                            {ListadoLineas.map(x =>(
                                                <tr>
                                                    <td>{x.cantidad}</td>
                                                    <td>{x.descripcionArticulo }</td>
                                                  
                                                    <td hidden={!Empresa.itbisIncluido}>${x.precio.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                    <td hidden={!Empresa.itbisIncluido}>${(x.precio * x.cantidad ).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                   
                                                    <td hidden={Empresa.itbisIncluido}>${(x.precio + x.itbis).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                    <td hidden={Empresa.itbisIncluido}>${((x.precio + x.itbis) * x.cantidad ).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                                    </tr>
                                            
                                           ) )}
                                                </tbody>
                                        </table>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div class="bill-info">
                                        <div style={{ width: "70%" }} >
                                        <b> Comentario:</b> {Listado.comentario }
                                        </div>
                                        <div style={{ width: "8%" }}></div>
                                        <div class="" style={{ width: "22%" }} hidden={!Empresa.itbisIncluido } >
                                         
                                            <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: (Listado.subTotal + Listado.totalITBIS) })}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: Listado.subTotal })}</div>
                                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                                                <div><b>Cobertura.:</b> {currencyFormatter({ currency: "USD", value: Listado.montoTotalCobertura })}</div>
                                            <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                                        </div>
                                        <div class="" style={{ width: "20%" }} hidden={Empresa.itbisIncluido} >
                                          
                                            <div hidden={Listado.tipoComprobante != 1}><b>Sub-Total: </b>{currencyFormatter({ currency: "USD", value: (Listado.subTotal + Listado.totalITBIS) })}</div>
                                            <div hidden={Listado.tipoComprobante == 1}><b>Sub-Total: </b>{currencyFormatter({currency: "USD",value: Listado.subTotal})}</div>
                                            <div><b>Desc.:</b> {currencyFormatter({ currency: "USD", value: Listado.totalDescuento })}</div>
                                            <div hidden={Listado.tipoComprobante == 1} ><b>18% ITBIS:</b> {currencyFormatter({ currency: "USD", value: Listado.totalITBIS })}</div>
                                            <div><b>Total:</b> {currencyFormatter({ currency: "USD", value: Listado.totalPago })}</div>


                                        </div>
                                    </div>
                                    <br></br>
                                    <br></br> 
                                    <div class="bill-info">
                                       

                                        <div style={{
                                            //borderTop: '2px solid',
                                            width: '30%',
                                            textAlign: 'center'} }>
                                            {/*<img class="card-img-top" src="./imagen/FirmaApatech.jpg" style={{ width: '200px', height: '90px', borderBottom: '2px solid' }} />*/}
                                         Realizado Por
                                        </div>
                                     
                                        <div style={{
                                           // borderTop: '2px solid',
                                            width: '30%', 
                                            textAlign: 'center'
                                        }}>
                                            <div style={{ width: '200px', borderBottom: '2px solid' }}></div>
                                       Recibido Por


                                        </div>
                                    </div>


                                        </div>

                                    </body>
                                </html>

                            <div hidden class="recibo-container">
                                <div class="recibo-header">
                                    <div class="logo-section">
                                        <div class="logo-nombre-container">
                                            <div class="logo">
                                              
                                                <svg viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10,20 Q20,5 30,20" stroke="#2a5885" fill="none" stroke-width="3" />
                                                    <path d="M20,20 Q30,35 40,20" stroke="#2a5885" fill="none" stroke-width="3" />
                                                    <circle cx="45" cy="20" r="8" stroke="#2a5885" fill="none" stroke-width="2" />
                                                </svg>
                                            </div>
                                            <div class="company-info">
                                                <div class="company-name">CENTRO ENDOSCÓPICO</div>
                                                <div class="company-subname">DIGESTIVO INTEGRAL, S.A.S.</div>
                                            </div>
                                        </div>
                                        <div class="address-section-header">
                                            PEDRO J. ESPAILLAT No. 103 (ENTRE SANTIAGO Y ARÍSTIDES FIALLO CABRAL)<br/>
                                                TELS.: 809-221-6924 • FAX: 809-221-9629 • SANTO DOMINGO, R.D.
                                        </div>
                                    </div>
                                    <div class="recibo-info">
                                        <div class="recibo-number">No. <span id="preview-recibo-number">7961</span></div>
                                    </div>
                                    <div class="fecha-columna-contenedor">
                                        <div class="recibo-ingreso-title">Recibo de Ingreso</div>
                                        <div class="fecha-table">
                                            <div class="fecha-header">FECHA</div>
                                            <div class="fecha-columns">
                                                <div class="fecha-column">DIA</div>
                                                <div class="fecha-column">MES</div>
                                                <div class="fecha-column">AÑO</div>
                                            </div>
                                            <div class="fecha-values">
                                                <div class="fecha-value"><span id="preview-dia">15</span></div>
                                                <div class="fecha-value"><span id="preview-mes">10</span></div>
                                                <div class="fecha-value"><span id="preview-año">2024</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="address-section"></div>
                                <div class="form-row">
                                    <div class="form-label">Recibí de:</div>
                                    <div class="form-value" id="preview-recibi-de">Paciente Ejemplo</div>
                                </div>
                                <div class="form-row">
                                    <div class="form-label">La suma de:</div>
                                    <div class="form-value">
                                        <div class="suma-de-container">
                                            <span id="preview-suma-de">Mil Quinientos</span>

                                        </div>
                                    </div>
                                    <div class="suma-de-container">
                                        <div class="amount-row">
                                            <span class="currency">RD$ <span id="preview-monto">1,500.00</span></span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-label">Por concepto de: </div>
                                    <div class="form-value" id="preview-concepto">Consulta médica</div>
                                </div>
                                <div class="payment-signature-container">
                                   
                                    <div class="payment-section">
                                        <div class="payment-row">
                                            <div class="payment-label">Efectivo</div>
                                            <div class="payment-value">
                                                <span class="currency">RD$</span>
                                                <span class="amount"><span id="preview-efectivo">500.00</span></span>
                                            </div>
                                        </div>
                                        <div class="payment-row">
                                            <div class="payment-label">Cheque</div>
                                            <div class="payment-value">
                                                <span class="currency">RD$</span>
                                                <span class="amount"><span id="preview-cheque">500.00</span></span>
                                            </div>
                                        </div>
                                        <div class="payment-row">
                                            <div class="payment-label">Otro</div>
                                            <div class="payment-value">
                                                <span class="currency">RD$</span>
                                                <span class="amount"><span id="preview-otro">500.00</span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="signature-area" id="preview-recibido-por">
                                        <div id="firma-nombre">Dra. Ejemplo</div>
                                       
                                        <hr/>
                                           
                                            Recibido por:
                                    </div>
                                </div>
                            </div>

                    </div>

                </div>
            </div>
            </div>
        </>
        )

}
export default ImpresionFactura;